import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axiosClient, { getData } from '../global/Globalapi';
import { IoArrowBackOutline } from "react-icons/io5";
import FilterSidebar from "./DynamicComp/FilterSidebar";
import { encodeId } from "../global/Globalfunction";
import { storeEncodedLead } from "../global/Globalfunction";
import { useRef } from "react";
import Fuse from "fuse.js";

const ProductListing = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const [activeFilters, setActiveFilters] = useState({});
  const baseURL = axiosClient.defaults.baseURL;
const fuseRef = useRef(null);
const [allProducts, setAllProducts] = useState([]);

  const getQueryParam = (key) => {
    return new URLSearchParams(location.search).get(key);
  };

  const buildQueryParams = (filters) => {
    const params = new URLSearchParams();
    
    console.log('🔧 Building query params from filters:', filters);
    
    // Category filter
    if (filters.category && filters.category.length > 0) {
      filters.category.forEach(cat => params.append('category', cat));
    }
    
    // Price filter
    if (filters.price) {
      const { min, max } = filters.price;
      console.log('💰 Price filter values:', { min, max, minType: typeof min, maxType: typeof max });
      
      const minNum = Number(min);
      const maxNum = Number(max);
      
      if (!isNaN(minNum) && minNum !== null && minNum !== undefined) {
        params.append('price_min', minNum);
        console.log('✅ Added price_min:', minNum);
      }
      if (!isNaN(maxNum) && maxNum !== null && maxNum !== undefined) {
        params.append('price_max', maxNum);
        console.log('✅ Added price_max:', maxNum);
      }
    }
    
    // Color filter
    if (filters.color && filters.color.length > 0) {
      filters.color.forEach(color => params.append('color', color));
    }
    
    // Discount filter
    if (filters.discount && filters.discount.length > 0) {
      filters.discount.forEach(disc => params.append('discount', disc));
    }
    
    const queryString = params.toString();
    console.log('🔗 Final Query String:', queryString);
    return queryString;
  };

  const handleFilterChange = (filters) => {
    console.log("🎯 Filter changed:", JSON.stringify(filters, null, 2));
    setActiveFilters(filters);
  };
/////////////////////////////////////////////////////////////
useEffect(() => {
  const url = window.location.href;
  const params = new URL(url).searchParams;

  const campaign_id = params.get("campaign_id");
  const affiliate_user_id = params.get("affiliate_user_id");
  const affiliated_campaign_id = params.get("affiliated_campaign_id");

  // If NO affiliate params → do not track
  if (!campaign_id && !affiliate_user_id && !affiliated_campaign_id) return;

  console.log("🟢 Lead detected on Shopping page");
  storeEncodedLead(url); // Pass full URL
}, [location.search]); 
useEffect(() => {
  const loadAllProducts = async () => {
    try {
      const res = await getData("/search/all");

      if (res?.data?.data && Array.isArray(res.data.data)) {
        setAllProducts(res.data.data);

        fuseRef.current = new Fuse(res.data.data, {
          keys: [
            "product_name",
            "description",
            "category_name",
            "product_type_name",
            "attributes",
          ],
          threshold: 0.35,
        });

        console.log("🔍 Fuse initialized:", res.data.data.length);
      }
    } catch (err) {
      console.error("❌ Failed to load all products", err);
    }
  };

  loadAllProducts();
}, []);
useEffect(() => {
  const searchQuery = getQueryParam("search");

  setLoading(true);

  // 🔍 SEARCH using Fuse
  if (searchQuery && searchQuery.trim() !== "") {
    setSearchKeyword(searchQuery);

    if (fuseRef.current) {
      const results = fuseRef.current.search(searchQuery);
      const items = results.map(r => r.item);

      setProducts(items);
      setPagination(null);
    } else {
      setProducts([]);
    }

    setLoading(false);
    return;
  }

  // 🎯 FILTERS (backend)
  const hasActiveFilters =
    (activeFilters.category && activeFilters.category.length > 0) ||
    (activeFilters.color && activeFilters.color.length > 0) ||
    (activeFilters.discount && activeFilters.discount.length > 0) ||
    activeFilters.price;

  if (hasActiveFilters) {
    const fetchFiltered = async () => {
      try {
        const queryString = buildQueryParams(activeFilters);
        const res = await getData(`/filter?${queryString}`);

        setProducts(res?.data?.data || []);
        setPagination(res?.data?.pagination || null);
      } catch (err) {
        console.error("❌ Filter error", err);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFiltered();
    return;
  }

  // 📦 DEFAULT: show all products
  setProducts(allProducts);
  setPagination(null);
  setLoading(false);

}, [location.search, activeFilters, allProducts]);

  // useEffect(() => {
  //   let isMounted = true;
    
  //   const fetchProducts = async () => {
  //     if (!isMounted) return;
  //     setLoading(true);
      
  //     try {
  //       const groupId = getQueryParam('product');
  //       const searchQuery = getQueryParam('search');
        
  //       // Set search keyword for display
  //       if (searchQuery) {
  //         setSearchKeyword(searchQuery);
  //       } else {
  //         setSearchKeyword('');
  //       }
        
  //       const hasActiveFilters = 
  //         (activeFilters.category && activeFilters.category.length > 0) ||
  //         (activeFilters.color && activeFilters.color.length > 0) ||
  //         (activeFilters.discount && activeFilters.discount.length > 0) ||
  //         (activeFilters.price && (
  //           activeFilters.price.min !== undefined || 
  //           activeFilters.price.max !== undefined
  //         ));
        
  //       console.log('🔍 Search Query:', searchQuery);
  //       console.log('🔍 Has Active Filters:', hasActiveFilters);
  //       console.log('🔍 Active Filters:', JSON.stringify(activeFilters, null, 2));
        
  //       // PRIORITY 1: Search Query (from search bar)
  //       if (searchQuery && searchQuery.trim() !== '') {
  //         console.log('🔎 Fetching search results for:', searchQuery);
          
  //         const response = await fetch(`${baseURL}/advanced-search`, {
  //           method: 'POST',
  //           headers: { 'Content-Type': 'application/json' },
  //           body: JSON.stringify({ keyword: searchQuery }),
  //         });

  //         if (!response.ok) throw new Error('Search failed');

  //         const data = await response.json();
          
  //         if (!isMounted) return;
          
  //         console.log('📥 Search Response:', data);
          
  //         if (data.results && Array.isArray(data.results)) {
  //           console.log(`✅ Setting ${data.results.length} search results`);
  //           setProducts(data.results);
  //           setPagination(null);
  //         } else {
  //           console.log('❌ No search results');
  //           setProducts([]);
  //           setPagination(null);
  //         }
  //       }
  //       // PRIORITY 2: Filters (from sidebar)
  //       else if (hasActiveFilters) {
  //         const queryString = buildQueryParams(activeFilters);
  //         const url = `/filter${queryString ? `?${queryString}` : ''}`;
          
  //         console.log('📡 Fetching filtered products from:', url);
  //         const response = await getData(url);
  //         const apiData = response?.data;
          
  //         if (!isMounted) return;
          
  //         if (apiData && apiData.success === true) {
  //           if (Array.isArray(apiData.data)) { 
  //             console.log(`✅ Setting ${apiData.data.length} filtered products`);
  //             setProducts(apiData.data); 
  //             setPagination(apiData.pagination || null);
  //           } else {
  //             console.error('❌ apiData.data is not an array');
  //             setProducts([]);
  //             setPagination(null);
  //           }
  //         } else if (response && Array.isArray(response.data)) {
  //           console.log(`✅ Setting ${response.data.length} products (no success flag)`);
  //           setProducts(response.data);
  //           setPagination(response.pagination || null);
  //         } else if (Array.isArray(response)) {
  //           console.log(`✅ Setting ${response.length} products (direct array)`);
  //           setProducts(response);
  //           setPagination(null);
  //         } else { 
  //           console.error('❌ Invalid response format');
  //           setProducts([]);
  //           setPagination(null);
  //         }
  //       }
  //       // PRIORITY 3: Category or All Products
  //       else {
  //         const url = groupId ? `/product/category/${groupId}` : '/product';
  //         console.log('📦 Fetching all products from:', url);
          
  //         const response = await getData(url);
  //         const apiData = response?.data;
          
  //         if (!isMounted) return;
          
  //         if (apiData?.success && Array.isArray(apiData.data)) {
  //           console.log(`✅ Setting ${apiData.data.length} products`);
  //           setProducts(apiData.data);  
  //         } else if (Array.isArray(response?.data)) {
  //           console.log(`✅ Setting ${response.data.length} products (no success flag)`);
  //           setProducts(response.data);
  //         } else if (Array.isArray(response)) {
  //           console.log(`✅ Setting ${response.length} products (direct array)`);
  //           setProducts(response);
  //         } else {
  //           console.error('❌ Invalid response format');
  //           setProducts([]);
  //         }
  //         setPagination(apiData?.pagination || null);
  //       }
  //     } catch (err) {
  //       console.error('❌ Fetch error:', err);
  //       setProducts([]);
  //       setPagination(null);
  //     } finally {
  //       if (isMounted) {
  //         setLoading(false);
  //       }
  //     }
  //   };

  //   fetchProducts();
    
  //   return () => {
  //     isMounted = false;
  //   };
  // }, [activeFilters, location.search, baseURL]);

  useEffect(() => {
  let isMounted = true;

  const fetchProducts = async () => {
    if (!isMounted) return;
    setLoading(true);

    try {
      const groupId = getQueryParam('product');
      const searchQuery = getQueryParam('search');

      setSearchKeyword(searchQuery || '');

      const hasActiveFilters =
        (activeFilters.category?.length > 0) ||
        (activeFilters.color?.length > 0) ||
        (activeFilters.discount?.length > 0) ||
        (activeFilters.price &&
          (activeFilters.price.min !== undefined ||
           activeFilters.price.max !== undefined));

      let response;
      let productsData = [];

      // ✅ PRIORITY 1: FILTERS
      if (hasActiveFilters) {
        const queryString = buildQueryParams(activeFilters);
        response = await getData(`/filter${queryString ? `?${queryString}` : ''}`);
        productsData = response?.data?.data || response?.data || [];
      }
      // ✅ PRIORITY 2: CATEGORY / ALL PRODUCTS
      else {
        const url = groupId ? `/product/category/${groupId}` : '/product';
        response = await getData(url);
        productsData = response?.data?.data || response?.data || [];
      }

      // ✅ CLIENT-SIDE SEARCH (NO API)
      if (searchQuery && searchQuery.trim() !== '') {
        productsData = productsData.filter(p =>
          p.product_name?.toLowerCase().includes(searchQuery.toLowerCase())
        );
      }

      if (!isMounted) return;

      setProducts(productsData);
      setPagination(response?.data?.pagination || null);
    } catch (err) {
      console.error('❌ Fetch error:', err);
      setProducts([]);
      setPagination(null);
    } finally {
      if (isMounted) setLoading(false);
    }
  };

  fetchProducts();

  return () => {
    isMounted = false;
  };
}, [activeFilters, location.search, baseURL]);

  useEffect(() => {
    console.log('🎨 Component Re-render:', { 
      productsCount: products.length, 
      loading,
      searchKeyword
    });
  }, [products, loading, searchKeyword]);

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  const clearAllFilters = () => {
    console.log('🗑️ Clearing all filters and search');
    setActiveFilters({});
    setSearchKeyword('');
    navigate('/shopping'); // Clear URL params
  };

  if (loading) {
    return (
      <div className="flex min-h-screen bg-gray-50">
        <div className="flex-shrink-0">
          <FilterSidebar onFilterChange={handleFilterChange} />
        </div>
        <div className="flex-1 flex justify-center items-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-xl text-gray-600">Loading products...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-gray-50">
      <div className="flex-shrink-0">
        <FilterSidebar onFilterChange={handleFilterChange} />
      </div>

      <div className="flex-1 py-6 px-4 md:px-8 lg:px-16">
        <div className="mb-4 flex items-center">
          <button 
            onClick={() => navigate(-1)} 
            className="text-sm bg-[#c97c5d] hover:bg-orange-300 text-black-700 px-4 py-2 rounded-lg transition mb-4"
          >
            <IoArrowBackOutline className="text-2xl " />
          </button>
        </div>

        <div className="mb-8">
          <h1 className="text-3xl font-bold text-center mb-4">
            {searchKeyword ? `Search Results for "${searchKeyword}"` : 'Our Products'}
          </h1>
          
          {(searchKeyword || Object.keys(activeFilters).length > 0) && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
              <div className="flex items-center justify-between flex-wrap gap-2">
                <p className="text-sm text-gray-700">
                  {searchKeyword && (
                    <span className="font-semibold">
                      🔍 Searching for: "{searchKeyword}"
                    </span>
                  )}
                  {activeFilters.category?.length > 0 && ` • ${activeFilters.category.length} Categories`}
                  {activeFilters.color?.length > 0 && ` • ${activeFilters.color.length} Colors`}
                  {activeFilters.discount?.length > 0 && ` • ${activeFilters.discount.length} Discounts`}
                  {activeFilters.price && ` • Price Range`}
                </p>
                <button
                  onClick={clearAllFilters}
                  className="text-sm bg-red-500 hover:bg-red-600 text-white px-4 py-1 rounded-lg transition"
                >
                  Clear All
                </button>
              </div>
            </div>
          )}

          <div className="text-center">
            {pagination ? (
              <p className="text-gray-600">
                Showing <span className="font-semibold">{products.length}</span> of{' '}
                <span className="font-semibold">{pagination.total_items}</span> products
              </p>
            ) : (
              <p className="text-gray-600">
                <span className="font-semibold">{products.length}</span> products found
              </p>
            )}
          </div>
        </div>

        {products.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {products.map((product) => {
              const discountPercent = product.mrp_price > 0 
                ? Math.round(((product.mrp_price - product.net_price_rtl) / product.mrp_price) * 100)
                : 0;

              return (
                <div 
                  key={product.product_id} 
                  className="bg-white rounded-lg shadow hover:shadow-2xl transition-all duration-300 cursor-pointer overflow-hidden group"
                  onClick={() => handleProductClick(product.product_id)}
                >
                  <div className="relative overflow-hidden">
                    <img
                      src={
                        product.image_file || product.file_name || (product.images && product.images[0])
                          ? `${baseURL}/uploads/${product.image_file || product.file_name || product.images[0]}`
                          : 'https://via.placeholder.com/300x200?text=No+Image'
                      }
                      alt={product.product_name}
                      loading="lazy"
                      className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                    
                    {discountPercent > 0 && (
                      <div className="absolute top-2 left-2 bg-red-500 text-white px-2 py-1 rounded-md text-xs font-bold">
                        {discountPercent}% OFF
                      </div>
                    )}
                    
                    {product.Feature_product === 1 && (
                      <div className="absolute top-2 right-2 bg-yellow-400 text-gray-900 px-2 py-1 rounded-md text-xs font-bold">
                        ⭐ Featured
                      </div>
                    )}
                    
                    {product.New_Product === 1 && (
                      <div className="absolute bottom-2 right-2 bg-green-500 text-white px-2 py-1 rounded-md text-xs font-bold">
                        🆕 New
                      </div>
                    )}
                  </div>

                  <div className="p-4">
                    <h3 className="font-semibold mb-2 text-gray-800 line-clamp-2 h-12">
                      {product.product_name}
                    </h3>
                    
                    {product.category_name && (
                      <p className="text-xs text-gray-500 mb-2">
                        {product.category_name}
                      </p>
                    )}
                    
                    {product.product_type_name && (
                      <p className="text-xs text-blue-600 mb-2">
                        {product.product_type_name}
                      </p>
                    )}
                    
                    <div className="mt-3 space-y-2">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-gray-900 text-xl md:text-2xl font-bold">
                          ₹{Number(product.unit_selling_price).toLocaleString('en-IN')}
                        </span>
                        {product.mrp_price > product.net_price_rtl && (
                          <span className="text-gray-500 text-sm line-through">
                            ₹{Number(product.mrp_price).toLocaleString('en-IN')}
                          </span>
                        )}
                      </div>
                      
                      {product.discount_amt_rtl > 0 && (
                        <div className="flex items-center gap-2">
                          <span className="bg-green-100 text-green-700 text-xs px-2 py-1 rounded font-medium">
                            Save ₹{Number(product.discount_amt_rtl).toLocaleString('en-IN')}
                          </span>
                        </div>
                      )}
                    </div>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleProductClick(encodeId(product.product_id));
                      }}
                      className="w-full mt-4 bg-[#c97c5d] hover:bg-orange-300 text-white py-2 rounded-lg transition duration-200 text-sm font-semibold"
                    >
                      View Details
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-16 bg-white rounded-lg shadow">
            <svg
              className="mx-auto h-24 w-24 text-gray-400 mb-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
              />
            </svg>
            <h3 className="text-xl font-semibold text-gray-700 mb-2">
              {searchKeyword ? `No results found for "${searchKeyword}"` : 'No Products Found'}
            </h3>
            <p className="text-gray-500 mb-6">
              {searchKeyword 
                ? 'Try different keywords or browse our categories' 
                : 'Try adjusting your filters to see more products'}
            </p>
            <button
              onClick={clearAllFilters}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-200 font-semibold"
            >
              {searchKeyword ? 'Clear Search' : 'Clear All Filters'}
            </button>
          </div>
        )}

        {pagination && pagination.total_pages > 1 && (
          <div className="mt-8 flex justify-center items-center gap-4">
            <button
              disabled={pagination.current_page === 1}
              className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-300 transition"
            >
              Previous
            </button>
            <span className="text-gray-600">
              Page <span className="font-semibold">{pagination.current_page}</span> of{' '}
              <span className="font-semibold">{pagination.total_pages}</span>
            </span>
            <button
              disabled={pagination.current_page === pagination.total_pages}
              className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-300 transition"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
// const ProductListing = () => {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [pagination, setPagination] = useState(null);
//   const [searchKeyword, setSearchKeyword] = useState('');
//   const [activeFilters, setActiveFilters] = useState({});
//   const [allProducts, setAllProducts] = useState([]);
//   const fuseRef = useRef(null);

//   const location = useLocation();
//   const navigate = useNavigate();
//   const baseURL = axiosClient.defaults.baseURL;

//   const getQueryParam = (key) => {
//     return new URLSearchParams(location.search).get(key);
//   };

//   const buildQueryParams = (filters) => {
//     const params = new URLSearchParams();

//     if (filters.category && filters.category.length > 0) {
//       filters.category.forEach(cat => params.append('category', cat));
//     }

//     if (filters.price) {
//       const { min, max } = filters.price;
//       if (!isNaN(Number(min))) params.append('price_min', Number(min));
//       if (!isNaN(Number(max))) params.append('price_max', Number(max));
//     }

//     if (filters.color && filters.color.length > 0) {
//       filters.color.forEach(color => params.append('color', color));
//     }

//     if (filters.discount && filters.discount.length > 0) {
//       filters.discount.forEach(disc => params.append('discount', disc));
//     }

//     return params.toString();
//   };

//   const handleFilterChange = (filters) => {
//     setActiveFilters(filters);
//   };

//   useEffect(() => {
//     const url = window.location.href;
//     const params = new URL(url).searchParams;

//     const campaign_id = params.get("campaign_id");
//     const affiliate_user_id = params.get("affiliate_user_id");
//     const affiliated_campaign_id = params.get("affiliated_campaign_id");

//     if (!campaign_id && !affiliate_user_id && !affiliated_campaign_id) return;

//     storeEncodedLead(url);
//   }, [location.search]);

//   useEffect(() => {
//     let isMounted = true;

//     const fetchProducts = async () => {
//       if (!isMounted) return;
//       setLoading(true);

//       try {
//         const groupId = getQueryParam('product');
//         const searchQuery = getQueryParam('search');

//         if (searchQuery) setSearchKeyword(searchQuery);
//         else setSearchKeyword('');

//         const hasActiveFilters =
//           (activeFilters.category && activeFilters.category.length > 0) ||
//           (activeFilters.color && activeFilters.color.length > 0) ||
//           (activeFilters.discount && activeFilters.discount.length > 0) ||
//           (activeFilters.price && (
//             activeFilters.price.min !== undefined ||
//             activeFilters.price.max !== undefined
//           ));

//         const fullRes = await getData("/search/all");

//         if (fullRes?.data?.data && Array.isArray(fullRes.data.data)) {
//           setAllProducts(fullRes.data.data);
//           fuseRef.current = new Fuse(fullRes.data.data, {
//             keys: [
//               "product_name",
//               "description",
//               "category_name",
//               "product_type_name",
//               "attributes"
//             ],
//             threshold: 0.35,
//           });
//         }

//         if (searchQuery && searchQuery.trim() !== '') {
//           if (fuseRef.current) {
//             const fuseResults = fuseRef.current.search(searchQuery);
//             const items = fuseResults.map(r => r.item);
//             setProducts(items);
//             setPagination(null);
//           } else {
//             setProducts([]);
//             setPagination(null);
//           }
//         }

//         else if (hasActiveFilters) {
//           const queryString = buildQueryParams(activeFilters);
//           const url = `/filter${queryString ? `?${queryString}` : ''}`;
//           const response = await getData(url);
//           const apiData = response?.data;

//           if (!isMounted) return;

//           if (apiData?.success && Array.isArray(apiData.data)) {
//             setProducts(apiData.data);
//             setPagination(apiData.pagination || null);
//           } else {
//             setProducts([]);
//             setPagination(null);
//           }
//         }

//         else {
//           const url = groupId ? `/product/category/${groupId}` : '/product';
//           const response = await getData(url);
//           const apiData = response?.data;

//           if (!isMounted) return;

//           if (apiData?.success && Array.isArray(apiData.data)) {
//             setProducts(apiData.data);
//           } else {
//             setProducts([]);
//           }
//           setPagination(apiData?.pagination || null);
//         }

//       } catch (err) {
//         setProducts([]);
//         setPagination(null);
//       } finally {
//         if (isMounted) setLoading(false);
//       }
//     };

//     fetchProducts();
//     return () => { isMounted = false; };
//   }, [activeFilters, location.search, baseURL]);

//   const handleProductClick = (productId) => {
//     navigate(`/product/${productId}`);
//   };

//   const clearAllFilters = () => {
//     setActiveFilters({});
//     setSearchKeyword('');
//     navigate('/shopping');
//   };

//   if (loading) {
//     return (
//       <div className="flex min-h-screen bg-gray-50">
//         <FilterSidebar onFilterChange={handleFilterChange} />
//         <div className="flex-1 flex justify-center items-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div>
//     <div className="flex min-h-screen bg-gray-50">
//       <FilterSidebar onFilterChange={handleFilterChange} />

//       <div className="flex-1 py-6 px-4 md:px-8 lg:px-16">
//         <div className="mb-4 flex items-center">
//           <button
//             onClick={() => navigate(-1)}
//             className="flex items-center text-black font-semibold"
//           >
//             <IoArrowBackOutline className="text-2xl mr-2" />
//             Back
//           </button>
//         </div>

//         <h1 className="text-3xl font-bold text-center mb-6">
//           {searchKeyword ? `Search Results for "${searchKeyword}"` : 'Our Products'}
//         </h1>

//         {products.length > 0 ? (
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//             {products.map(product => (
//               <div
//                 key={product.product_id}
//                 className="bg-white rounded-lg shadow cursor-pointer"
//                 onClick={() => handleProductClick(encodeId(product.product_id))}
//               >
//                 <img
//                   src={
//                     product.file_name
//                       ? `${baseURL}/uploads/${product.file_name}`
//                       : 'https://via.placeholder.com/300x200?text=No+Image'
//                   }
//                   className="h-48 w-full object-cover"
//                   alt={product.product_name}
//                 />
//                 <div className="p-4">
//                   <h3 className="font-semibold line-clamp-2">
//                     {product.product_name}
//                   </h3>
//                   <p className="font-bold text-lg">
//                     ₹{Number(product.net_price_rtl).toLocaleString('en-IN')}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div className="text-center py-20 bg-white rounded-lg shadow">
//             <h3 className="text-xl font-semibold mb-2">
//               {searchKeyword ? `No results found for "${searchKeyword}"` : 'No Products Found'}
//             </h3>
//             <button
//               onClick={clearAllFilters}
//               className="bg-blue-600 text-white px-6 py-2 rounded-lg"
//             >
//               Clear
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
    
//     </div>
//   );
// };
export default ProductListing;